import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch,
        popUpMessageChange, 
        closedCardsGroupsChange,
        editCards,
        editFeaturesGroup, 
        editFigures } from '../../actions';

import { _ } from '../../functions/translator.js';

import SignatureCanvas from 'react-signature-canvas';
import { Button, 
        Checkbox, 
        FormControlLabel } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';

import Icon from '@mdi/react';
import { mdiEraser,
        mdiLoading } from '@mdi/js';

import SendIcon from '@material-ui/icons/Send';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { CircularProgress } from '@material-ui/core';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { CardsGroupStatus, ToggleActions } from '../../constants/constants';
import { showMessage } from '../../functions/popUpMessage.js';
import { getUsername } from '../../functions/getter.js';
import { toDataURL } from '../../functions/utils.js';
import { getProjectUsers } from '../../functions/getData.js';

class Signature extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            disableButton: true,
            sending: false,
            addRevision: false,
            checkClose: false,
            nonSignedUsers: null,
            loading: false,
            signatureLoaded: false,
            ratio: 1,
            canvasSize: 300,
            projectUsers: {}
        }
    }

    async componentDidMount() {
        let projectUsers = await getProjectUsers(window.project_id, false);
        this.setState({ projectUsers: projectUsers });
    }

    async componentDidUpdate(prevProps) {
        if (this.props.closedCardsGroups !== prevProps.closedCardsGroups) {
            if (this.props.closedCardsGroups.length) {
                this.setState({ loading: true });
                const urlPost = {
                    project_id: window.project_id,
                    cards_group_ids: this.props.closedCardsGroups
                }
                const response = await postData('/web-api/get-non-signed-users', urlPost);
                const nonSignedUsers = response.status === 'success' ? response.non_signed_users : null;
                this.setState({
                    loading: false,
                    nonSignedUsers: nonSignedUsers
                });
            } else {
                this.setState({ nonSignedUsers: null });
            }
        }
    } 

    handleOnErase = () => {
        this.sigCanvas.clear()
        this.setState({ disableButton: true })
    }

    handleOnSend = async () => {
        this.setState({ 
            disableButton: true,
            sending: true
        });
        let signature = this.sigCanvas.getTrimmedCanvas().toDataURL()
        const areClosedSelected = this.areClosedSelected();
        let urlPost = {
            project_id: window.project_id,
            cards_group_ids: this.props.closedCardsGroups,
            signature: signature,
            add_revision: !areClosedSelected && this.state.checkClose && this.state.addRevision,
            close: this.state.checkClose 
        }
        let response = await postData('/web-api/sign-cards-groups', urlPost)
        this.handleResponse(response)
    }

    handleOnEndSignature = () => {
        if (!this.sigCanvas.isEmpty()) {
            this.setState({ disableButton: false })
        }
    }

    handleClose = () => {
        if (this.props.signatureSwitch) {
            this.props.toggleSwitch(ToggleActions.SIGNATURE)
            this.setState({ signatureLoaded: false });
        }
    }

    handleResponse = (response) => {
        this.setState({ sending: false })
        this.handleClose();
        reloadCardsGroupsFeatures(this.props, this.props.closedCardsGroups)
        this.props.closedCardsGroupsChange([])

        let message = '';
        if (response.status === 'success') {
            if (this.state.checkClose) {
                message = _('¡Protocolos cerrados exitosamente!');
            } else {
                message = _('¡Protocolos firmados exitosamente!');
            }
        } else {
            if (this.state.checkClose) {
                message = _('Ocurrió un error al cerrar los protocolos');
            } else {
                message = _('Ocurrió un error al firmar los protocolos');
            }
        }
        showMessage(this.props, message);
    }

    handleOnCheckRevision = () => {
        this.setState({ addRevision: this.state.checkClose && !this.state.addRevision })
    }

    handleOnCheckClose = () => {
        this.setState({ checkClose: !this.state.checkClose })
    }
    
    areClosedSelected = () => {
        return this.props.closedCardsGroups.some((cardsGroupId) => {
            const cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            if (!cardsGroupData) return false;
            return cardsGroupData.attributes.status === CardsGroupStatus.CLOSED;
        });
    }

    handlePassWarning = () => {
        this.setState({ nonSignedUsers: null });
    }

    getNonSignedUsersHTML = () => {
        if (!this.state.nonSignedUsers) return;
        const nonSignedUsers = [];
        const sortedNonSignedUsers = Object.entries(this.state.nonSignedUsers).sort(this.sortByIndex);
        for (const [cardsGroupId, userIds] of sortedNonSignedUsers) {
            const cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            const index = cardsGroupData ? cardsGroupData.attributes.index : '-';
            const tr = [<td>{_('Protocolo') + 'N°' + ' ' + index}</td>];
            const usersTd = [];
            for (let i = 0; i < userIds.length; i++) {
                const userId = userIds[i];
                const isLastLoop = i + 1 === userIds.length;
                const username = getUsername(userId, this.props.projectUsers);
                usersTd.push(username);
                if (!isLastLoop) {
                    usersTd.push(<br></br>);
                }
            }
            tr.push(<td>{usersTd}</td>);
            const cardsGroupUrl = `/cards?project_id=${window.project_id}&cards_group_id=${cardsGroupId}`;
            tr.push(
                <td>
                    <a type="button" className="btn btn-inverse-light float-right" href={cardsGroupUrl} target="_blank" rel="noopener noreferrer" style={{height: '30px'}}>
                        <OpenInNew/>
                    </a>
                </td>
            )
            nonSignedUsers.push(<tr>{tr}</tr>);
        }
        return nonSignedUsers;
    }

    sortByIndex = (first, second) => {
        const firstCardsGroupId = first[0];
        const secondCardsGroupId = second[0];
        const firstCardsGroupData = this.props.projectData.cards_groups[firstCardsGroupId];
        const secondCardsGroupData = this.props.projectData.cards_groups[secondCardsGroupId];
        const firstIndex = firstCardsGroupData ? firstCardsGroupData.attributes.index : 0;
        const secondIndex = secondCardsGroupData ? secondCardsGroupData.attributes.index : 0;
        return firstIndex - secondIndex;
    }

    loadSignature = async () => {
        const userData = this.state.projectUsers[window.current_user_id];
        if (!userData) return;
        if (this.state.signatureLoaded) return;
        if (userData.attributes.signature_image_path) {
            const signatureUrl = `images/${userData.attributes.signature_image_path}`;
            toDataURL(signatureUrl, (dataURL) => {
                if (!this.sigCanvas) return;
                const config = { 
                    ratio: this.state.ratio,
                    width: this.state.canvasSize,
                    height: this.state.canvasSize,
                };
                this.sigCanvas.fromDataURL(dataURL, config);
                this.setState({ signatureLoaded: true });
                this.setState({ disableButton: false });
            });
        }
    }

    render(){   
        const render = this.props.signatureSwitch && this.props.closedCardsGroups.length > 0;
        const areClosedSelected = this.areClosedSelected();
        const renderWarning = this.state.nonSignedUsers && Object.keys(this.state.nonSignedUsers).length;
        const notDisplayClass = 'd-none';
        const nonSignedUsers = this.getNonSignedUsersHTML();
        const warningContainerClass = renderWarning && !this.state.loading ? '' : notDisplayClass;
        const signContainerClass = renderWarning || this.state.loading ? notDisplayClass: '';
        const loadingContainerClass = this.state.loading ? 'my-5 d-flex justify-content-center' : notDisplayClass;
        const sendingText = this.state.sending ? _('Enviando') + '...' : _('Enviar Firma');
        const sendingIcon = this.state.sending ? <Icon path={ mdiLoading } size='16px' color='#00d25b' spin={1}/> : <SendIcon/>;
        this.loadSignature();
        if (render) {
            return (
                <div>
                    <div className='sensitive-background' onClick={ this.handleClose }></div>
                    <div className="signature-card-layout card-color">
                        <div className={warningContainerClass}>
                            <h4 className='text-center mt-2 mx-3'>¡{_("Atención, faltan las siguientes firmas de usuarios en los protocolos seleccionados")}!</h4>
                            <div className='mt-4 mb-5 mx-2 non-signed-users-container'>
                                <table className='non-signed-users-table mx-auto'>
                                    {nonSignedUsers}
                                </table>
                            </div>
                            <div className="d-flex justify-content-around mt-4 mb-3 mx-4">
                                <Button variant="contained" className='confirm-success-button' onClick={ this.handlePassWarning }>
                                    { _('Continuar') }
                                </Button>
                                <Button variant="contained" className='confirm-cancel-button' onClick={ this.handleClose }>
                                    { _('Cancelar') }
                                </Button>
                            </div>
                        </div>
                        <div className={loadingContainerClass}>
                            <CircularProgress size={100}/>
                        </div>
                        <div className={signContainerClass}>
                            <h3 className='text-center mt-2 mb-4'>{_("Ingresar Firma")}</h3>
                            <div className='position-relative d-flex justify-content-center'>
                                <SignatureCanvas ref={(ref) => { this.sigCanvas = ref }} 
                                    canvasProps={{ className: 'signature-container'}} 
                                    onEnd={ this.handleOnEndSignature }/>
                                <Button variant="contained" onClick={ this.handleOnErase } className='button-canvas'>
                                    <Icon path={ mdiEraser }
                                        size={1}
                                        color="white"/>
                                </Button>
                            </div>
                            {/* <div className='check-revision-container'>
                            <FormControlLabel
                                className="mt-2"
                                control={
                                    <Checkbox
                                        onChange={this.handleOnCheckClose}
                                        color="primary"
                                        size="medium"
                                    />
                                }
                                label={
                                    <span className="text mr-2">
                                        { _('Cerrar Protocolos') }
                                        <Tooltip arrow 
                                            title={
                                                <span style={{color: 'black'}}>
                                                    {_('Si hay protocolos por revisar o con observaciones')},
                                                    <br></br>
                                                    {_('se le agregará una nueva revisión igualmente')}.
                                                </span>
                                            } placement="right">
                                            <InfoOutlinedIcon color='primary' style={{ fontSize: 20 }} className='float-right'/>
                                        </Tooltip>
                                    </span>
                                }
                            />  
                            </div>
                            <div className='check-revision-container'>
                            <FormControlLabel
                                className="mb-3"
                                control={
                                    <Checkbox
                                        onChange={this.handleOnCheckRevision}
                                        color="primary"
                                        size="medium"
                                    />
                                }
                                label={
                                    <span className="text">
                                        { _('Agregar nueva revisión') }
                                    </span>
                                }
                                disabled={areClosedSelected || !this.state.checkClose}
                            />  
                            </div> */}
                            <div className='d-flex justify-content-center mt-3 mb-2'>
                                <Button 
                                    variant="contained" 
                                    className='confirm-success-button' 
                                    onClick={ this.handleOnSend }
                                    disabled={ this.state.disableButton }>
                                    { sendingIcon }
                                    { sendingText }
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (<div></div>)
    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        projectUsers : state.projectUsers,
        signatureSwitch : state.switches.signature,
        closedCardsGroups : state.closedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        popUpMessageChange : popUpMessageChange,
        closedCardsGroupsChange : closedCardsGroupsChange,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Signature)